import { ERROR_MESSAGE } from 'components/common/ErrorMessage';
import {
  GET_MEAL_PRICES_V3_RESPONSE,
  GET_MEAL_PRICE_V3_RESPONSE,
  GET_MEAL_PRICE_V3_ERROR,
  CLEAR_MEAL_PRICES_V3,
} from 'lib/constants/v3Actions';

const PRICE_NOT_FOUND_FRIENDLY_MESSAGE = 'This meal is no longer available on your current plan.';
const initialState = {
  data: {},
  error: null,
};

const transformFormMealPrices = mealPrices => {
  return mealPrices.reduce((acc, mealPrice) => {
    acc[mealPrice.id] = { name: mealPrice.name, priceCents: mealPrice.priceCents };
    return acc;
  }, {});
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_MEAL_PRICES_V3_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.params.menuSlug]: transformFormMealPrices(action.response.mealPrices),
        },
        error: null,
      };
    case GET_MEAL_PRICE_V3_RESPONSE:
      return {
        ...state,
        data: {
          ...state.data,
          [action.params.menuSlug]: transformFormMealPrices([action.response.mealPrice]),
        },
        error: null,
      };
    case GET_MEAL_PRICE_V3_ERROR: {
      const status = action.response.status;
      let friendlyMessage = ERROR_MESSAGE;
      if (status === 404) {
        friendlyMessage = PRICE_NOT_FOUND_FRIENDLY_MESSAGE;
      }

      return {
        ...state,
        error: {
          friendlyMessage,
          message: action.response.error,
          status,
        },
      };
    }
    case CLEAR_MEAL_PRICES_V3:
      return {
        ...state,
        data: {
          ...state.data,
          [action.menuSlug]: {},
        },
        error: null,
      };
    default:
      return state;
  }
};

export const selectMealPrices = (state, menuSlug) => state.data[menuSlug] || {};

export const selectMealPrice = (state, menuSlug, mealId) =>
  selectMealPrices(state, menuSlug)[mealId];

export const selectMealPriceError = state => state.error;
